module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAkCAMAAABR74GsAAAAeFBMVEUAAADAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMCZl8HYAAAAJ3RSTlMABvoK9uffvlEqIQ/sy7ihmpSFfGVYGtjEsq6njHVsXklDOTHx1RXUYv1CAAAAqElEQVQoz4XSSRaCQAwE0AYEBJF5UGRQUfv+N5TULkm/Ry3/rioxOlXjwNLaWppX2D0SH1arN5L5Lcc7sGMY5MAzx9iBlxvh6cnxCnwx/AE/b4b9lzATOAA3hmlEGCbHmISEUXqMW0Y49IYFNS1qHnTS/fVWeleM7brB6j5iK7kAL5JL8KweCdxInsC15Bo8SW7AleQZXEpewIXkljQ2Mqtv88CodKNn/vGQHE3m1CP2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/left.png
// module id = JW0Z
// module chunks = 1